import React, { useState, useContext, useEffect } from 'react';
import {
    AppBar,
    Box,
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Toolbar,
    Typography,
    IconButton,
    Collapse,
} from '@mui/material';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import DataSaverOnIcon from '@mui/icons-material/DataSaverOn';
import MedicationIcon from '@mui/icons-material/Medication';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link as RouterLink } from 'react-router-dom';
import { blue } from '@mui/material/colors';  // Aqui você importa o blue
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';
import SettingsIcon from '@mui/icons-material/Settings';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { DataAtualDMYContext } from '../../context/DataAtualDMYContext';
import { TitleContext } from '../../context/TitleContext';
import SeletorContexto from '../auth/SeletorContexto';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import TuneIcon from '@mui/icons-material/Tune';
import RuleIcon from '@mui/icons-material/Rule';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaymentsIcon from '@mui/icons-material/Payments';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { useAuth } from '../../context/AuthContext';
import { filtrarMenu } from '../../services/permissoes';
import { filtrarMenuPorTela } from '../../services/rotasDesktop';
import useTelaPequena from '../layout/useTelaPequena';
import { EVENTO_ABRIR_MENU } from '../layout/BarraNavegacaoInferior';

const BarraSuperiorEsquerda = () => {
    const { title } = useContext(TitleContext);
    const { dataAtual } = useContext(DataAtualDMYContext);
    const { acesso } = useAuth();
    const celular = useTelaPequena();

    const [menuAberto, setMenuAberto] = useState(false); // Para controlar o menu principal
    // F1 (F-D1): o "Mais" da barra do rodapé do celular abre este menu
    useEffect(() => {
        const abrir = () => setMenuAberto(true);
        window.addEventListener(EVENTO_ABRIR_MENU, abrir);
        return () => window.removeEventListener(EVENTO_ABRIR_MENU, abrir);
    }, []);
    const [submenuAberto, setSubmenuAberto] = useState({}); // Para controlar múltiplos submenus

    // Ao abrir um submenu, os outros do mesmo nível (e o que estava aberto dentro deles) fecham sozinhos.
    // A chave é o caminho ("/Cadastros/Pacientes"); irmãos são os que têm o mesmo pai.
    const handleSubmenuToggle = (key) => {
        setSubmenuAberto((prev) => {
            if (prev[key]) {
                // fechar: este e o que estava aberto dentro dele
                const resto = {};
                Object.keys(prev).forEach((k) => {
                    if (k !== key && !k.startsWith(`${key}/`)) resto[k] = prev[k];
                });
                return resto;
            }
            const pai = key.slice(0, key.lastIndexOf('/'));
            const mantidos = {};
            Object.keys(prev).forEach((k) => {
                const ehIrmaoOuDescendente = k.startsWith(`${pai}/`);
                if (!ehIrmaoOuDescendente) mantidos[k] = prev[k];
            });
            return { ...mantidos, [key]: true };
        });
    };

    // Configuração dos itens do menu
    const itensMenu = [
        {
            texto: 'Início',
            icone: <HomeIcon />,
            to: '/',
        },
        {
            // F1: atendimentos do dia do profissional (só aparece para quem tem a rotina "atendimento")
            texto: 'Hoje',
            icone: <MedicationIcon />,
            to: '/hoje',
        },
        {
            texto: 'Agenda',
            icone: <CalendarMonthIcon />,
            to: '/agenda',
        },
        {
            texto: 'Cadastros',
            icone: <PersonAddAlt1Icon />,
            submenu: [
                {
                    texto: 'Quadro de Clinico',
                    icone: <GroupAddIcon />,
                    submenu: [
                        {
                            texto: 'Especializações',
                            icone: <MedicalInformationIcon />,
                            to: '/especializacoes',
                        },
                        {
                            texto: 'Tipos de Pagamentos',
                            icone: <PlaylistAddCircleIcon />,
                            to: '/tiposPagtosProf',
                        },
                        {
                            texto: 'Profissionais',
                            icone: <GroupAddIcon />,
                            to: '/profissionais',
                        },
                    ],
                },
                {
                    texto: 'Pacientes',
                    icone: <GroupAddIcon />,
                    submenu: [
                        {
                            texto: 'Pacientes',
                            icone: <PersonAddAlt1Icon />,
                            to: '/pacientes',
                        },
                        {
                            texto: 'Carteirinhas pendentes',
                            icone: <HealthAndSafetyIcon />,
                            to: '/carteirinhasPendentes',
                        },
                    ],
                },
                {
                    // Faturamento de planos de saúde: só aparece para quem o administrador liberou (rotina "titulosPlano")
                    texto: 'Planos Saúde',
                    icone: <ReceiptLongIcon />,
                    submenu: [
                        {
                            texto: 'Planos de Saúde',
                            icone: <HealthAndSafetyIcon />,
                            to: '/planosSaude',
                        },
                        {
                            texto: 'Motivos de glosa',
                            icone: <RuleIcon />,
                            to: '/motivosGlosa',
                        },
                        {
                            texto: 'Tabela de Preços',
                            icone: (<MonetizationOnIcon />),
                            to: '/tabelasPrecos'
                        },
                    ],
                },
                {
                    texto: 'Tipos de Consultas',
                    icone: <LibraryAddIcon />,
                    to: '/tiposConsultas',
                },
                {
                    // Recebimento do pacote particular (não é o pagamento ao profissional)
                    texto: 'Recebimento',
                    icone: <MonetizationOnIcon />,
                    submenu: [
                        {
                            texto: 'Formas de recebimento',
                            icone: <PlaylistAddCircleIcon />,
                            to: '/formasRecebimento',
                        },
                        {
                            texto: 'Condições de recebimento',
                            icone: <PlaylistAddCircleIcon />,
                            to: '/condicoesRecebimento',
                        },
                    ],
                },
            ],
        },
        {
            // Faturamento: só aparece para quem o administrador liberou (rotina "faturamento")
            texto: 'Faturamento',
            icone: <PaymentsIcon />,
            submenu: [
                {
                    texto: 'Planos de Saúde',
                    icone: <GroupAddIcon />,
                    submenu: [
                        {
                            texto: 'Títulos a faturar',
                            icone: <HealthAndSafetyIcon />,
                            to: '/titulosPlano',
                        },
                        {
                            texto: 'Faturas de planos',
                            icone: <ReceiptLongIcon />,
                            to: '/faturasPlano',
                        },
                    ],
                },
                {
                    texto: 'Contas a pagar',
                    icone: <GroupAddIcon />,
                    submenu: [
                        {},
                    ],
                },
            ],
        },
        {
            // Financeiro: só aparece para quem o administrador liberou (rotina "contasReceber")
            texto: 'Financeiro',
            icone: <PaymentsIcon />,
            submenu: [
                {
                    texto: 'Contas a receber',
                    icone: <GroupAddIcon />,
                    submenu: [
                        {
                            texto: 'CR - Particular',
                            icone: <PaymentsIcon />,
                            to: '/contasReceber',
                        },
                        {
                            texto: 'CR-Planos de Saúde',
                            icone: <ReceiptLongIcon />,
                            to: '/notasPlano',
                        },
                    ],
                },
                {
                    texto: 'Contas a pagar',
                    icone: <GroupAddIcon />,
                    submenu: [
                        {},
                    ],
                },
            ],
        },

        {
            // R1: relatórios (Administrador ou perfil com a rotina liberada; sem exceção de Admin Clínico, D18)
            texto: 'Relatórios',
            icone: <AssessmentIcon />,
            submenu: [
                {
                    // rotina "relatoriosFinanceiros": só aparece para quem o administrador liberou
                    texto: 'Contas a receber',
                    icone: <PaymentsIcon />,
                    submenu: [
                        {
                            texto: 'Títulos a receber - Geral',
                            icone: <RequestQuoteIcon />,
                            to: '/relatorios/financeiro/a-receber',
                        },
                        {
                            texto: 'Títulos baixados - Geral',
                            icone: <PaymentsIcon />,
                            to: '/relatorios/financeiro/baixados',
                        },
                        {
                            texto: 'Descontos e acréscimos concedidos',
                            icone: <RequestQuoteIcon />,
                            to: '/relatorios/financeiro/descontos',
                        },
                    ],
                },
                {
                    // rotina "relatoriosFinanceiros": só aparece para quem o administrador liberou
                    texto: 'Planos de Saúde',
                    icone: <GroupAddIcon />,
                    submenu: [
                        {
                            texto: 'Agendas por plano de saúde',
                            icone: <HealthAndSafetyIcon />,
                            to: '/relatorios/agendas-por-plano',
                        },
                    ],
                },
                {
                    // RV1: rotina "relatorioRenovacaoPacotes" (com telefones): só aparece para quem o administrador liberou
                    texto: 'Pacotes',
                    icone: <RequestQuoteIcon />,
                    submenu: [
                        {
                            texto: 'Pacotes e guias a renovar',
                            icone: <HealthAndSafetyIcon />,
                            to: '/relatorios/renovacao-pacotes',
                        },
                        {
                            // RV2: rotina "relatorioSaldoSemAgenda" (sem telefones): só aparece para quem o administrador liberou
                            texto: 'Saldo sem agenda',
                            icone: <HealthAndSafetyIcon />,
                            to: '/relatorios/saldo-sem-agenda',
                        },
                    ],
                },
            ],
        },
        {
            texto: 'Configurações',
            icone: <SettingsIcon />,
            submenu: [
                {
                    texto: 'Estados',
                    icone: (<MapIcon />),
                    to: '/estados'
                },
                {
                    texto: 'Cidades',
                    icone: (<LocationOnIcon />),
                    to: '/cidades'
                },
                {
                    texto: 'Usuários e perfis',
                    icone: (<AdminPanelSettingsIcon />),
                    to: '/usuarios'
                },
                {
                    texto: 'Perfis e permissões',
                    icone: (<RuleIcon />),
                    to: '/perfis'
                },
                {
                    // IMP: importação de planilhas do sistema anterior (só Administrador; só desktop)
                    texto: 'Importar planilhas',
                    icone: (<UploadFileIcon />),
                    to: '/importacoes'
                },
                {
                    // PS2: parâmetros do sistema (só Administrador; só desktop)
                    texto: 'Parâmetros do sistema',
                    icone: (<TuneIcon />),
                    to: '/parametros'
                },
                {
                    // F2.2: rastreabilidade do prontuário (Administrador ou Admin Clínico)
                    texto: 'Log de acessos e movimentações',
                    icone: (<ManageSearchIcon />),
                    to: '/log-acesso'
                },
            ],
        },
        {
            texto: 'Minha conta',
            icone: <AccountCircleIcon />,
            to: '/minha-conta',
        },

    ];
    // Menu por perfil (P-S1): só o que o perfil acessa — mesma regra das rotas (services/permissoes.js)
    // celular: só o que a tela do celular oferece (telas só de desktop não aparecem; P-C7)
    const itensMenuPerfil = filtrarMenuPorTela(filtrarMenu(itensMenu, acesso), celular);

    // Cada nível do submenu recua 16 px a mais (grupos e itens do mesmo nível ficam alinhados);
    // a chave do submenu aberto leva o caminho, para não confundir grupos com o mesmo nome.
    const renderItemMenu = (item, nivel, caminho) => {
        if (!item?.texto) return null;
        const recuo = 2 + nivel * 2;
        const iconeSx = nivel > 0 ? { minWidth: 36 } : undefined;
        const chave = `${caminho}/${item.texto}`;

        if (item.submenu) {
            const aberto = Boolean(submenuAberto[chave]);
            return (
                <React.Fragment key={chave}>
                    <ListItem disablePadding>
                        <ListItemButton sx={{ pl: recuo }} onClick={() => handleSubmenuToggle(chave)}>
                            <ListItemIcon sx={iconeSx}>{item.icone}</ListItemIcon>
                            <ListItemText primary={item.texto} sx={aberto ? { color: blue[500] } : {}} />
                            {aberto ? <ExpandLess sx={{ color: blue[500] }} /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={aberto} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {item.submenu.map((filho) => renderItemMenu(filho, nivel + 1, chave))}
                        </List>
                    </Collapse>
                </React.Fragment>
            );
        }

        return (
            <ListItem key={chave} disablePadding>
                <ListItemButton component={RouterLink} to={item.to} sx={{ pl: recuo }} onClick={() => setMenuAberto(false)}>
                    <ListItemIcon sx={iconeSx}>{item.icone}</ListItemIcon>
                    <ListItemText primary={item.texto} />
                </ListItemButton>
            </ListItem>
        );
    };

    return (
        <AppBar position="static" >
            <Toolbar sx={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)', alignItems: 'center', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                    <IconButton color="inherit" edge="start" aria-label="Abrir menu" onClick={() => setMenuAberto(true)}>
                        <MenuIcon />
                    </IconButton>
                    <Typography component="h1" variant="h6" noWrap sx={{ ml: { xs: 1, sm: 4 }, minWidth: 0 }}>
                        {title}
                    </Typography>
                    <Typography component="h1" variant="h6" noWrap sx={{ ml: 2, whiteSpace: 'nowrap', display: { xs: 'none', md: 'block' } }}>
                        {dataAtual}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {/* celular e tablet: símbolo branco de 28px (altura da barra na marca); desktop: logo completo */}
                    <Box
                        component="img"
                        src="/design-system/logos/terablues-simbolo-branco.svg"
                        alt="TeraBlues"
                        sx={{ height: 28, display: { xs: 'block', lg: 'none' } }}
                    />
                    <Box
                        component="img"
                        src="/design-system/logos/terablues-logo-horizontal-fundo-azul.png"
                        alt="TeraBlues"
                        sx={{ height: 48, display: { xs: 'none', lg: 'block' } }}
                    />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', minWidth: 0 }}>
                    <SeletorContexto />
                </Box>
            </Toolbar>

            <Drawer anchor="left" open={menuAberto} onClose={() => setMenuAberto(false)}>
                <Toolbar
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        px: [1],
                    }}
                >
                    <IconButton edge="start" onClick={() => setMenuAberto(false)}>
                        <ChevronLeftIcon />
                    </IconButton>
                </Toolbar>
                <Divider />
                <List sx={{ width: 280 }}>
                    {itensMenuPerfil.map((item) => renderItemMenu(item, 0, ''))}
                </List>
            </Drawer>
        </AppBar >
    );
};

export default BarraSuperiorEsquerda;



// import React, { useState, useContext } from 'react';
// import { AppBar, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography, IconButton, Collapse } from '@mui/material';
// import HomeIcon from '@mui/icons-material/Home';
// import MenuIcon from '@mui/icons-material/Menu';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
// import GroupAddIcon from '@mui/icons-material/GroupAdd';
// import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
// import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
// import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
// import DataSaverOnIcon from '@mui/icons-material/DataSaverOn';
// import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import { Link as RouterLink } from 'react-router-dom';

// const BarraSuperiorEsquerda = () => {
//     const [menuAberto, setMenuAberto] = useState(false); // Para controlar a abertura do menu
//     const [submenuAberto, setSubmenuAberto] = useState(false); // Para controlar a abertura do submenu "Cadastros"

//     // Configuração dos itens do menu
//     const itensMenu = [
//         {
//             texto: 'Início',
//             icone: <HomeIcon />,
//             to: '/',
//         },
//         {
//             texto: 'Cadastros',
//             icone: <PersonAddAlt1Icon />,
//             submenu: [
//                 {
//                     texto: 'Pacientes',
//                     icone: <PersonAddAlt1Icon />,
//                     to: '/pacientes',
//                 },
//                 {
//                     texto: 'Profissionais',
//                     icone: <PersonAddAlt1Icon />,
//                     submenu: [
//                         {
//                             texto: 'Profissionais',
//                             icone: <GroupAddIcon />,
//                             to: '/profissionais',
//                         },
//                         {
//                             texto: 'Tipos Pagtos',
//                             icone: (<PlaylistAddCircleIcon />),
//                             to: '/tiposPagtosProf',
//                         },
//                         {
//                             texto: 'Formas Atend.',
//                             icone: (<DataSaverOnIcon />),
//                             to: '/formasAtendProf',
//                         },
//                     ]
//                 },
//                 {
//                     texto: 'Planos de Saúde',
//                     icone: <HealthAndSafetyIcon />,
//                     to: '/planosSaude',
//                 },
//                 {
//                     texto: 'Tipos de Consultas',
//                     icone: (<LibraryAddIcon />),
//                     to: '/tiposConsultas',
//                 },
//             ],
//         },
//         {
//             texto: 'Especializações',
//             icone: <GroupAddIcon />,
//             to: '/especializacoes',
//         },
//         {
//             texto: 'Tipos de Consultas',
//             icone: <LibraryAddIcon />,
//             to: '/tiposConsultas',
//         },
//     ];

//     return (
//         <AppBar position="static">
//             <Toolbar>
//                 <MenuIcon sx={{ cursor: 'pointer' }} onClick={() => setMenuAberto(true)} />
//                 <Typography component="h1" variant="h6" noWrap sx={{ flexGrow: 1, ml: 4 }}>
//                     Sistema de Gestão
//                 </Typography>
//             </Toolbar>

//             <Drawer anchor="left" open={menuAberto} onClose={() => setMenuAberto(false)}>
//                 <Toolbar
//                     sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'flex-end',
//                         px: [1],
//                     }}
//                 >
//                     <IconButton edge="start" onClick={() => setMenuAberto(false)}>
//                         <ChevronLeftIcon />
//                     </IconButton>
//                 </Toolbar>
//                 <Divider />
//                 <List sx={{ width: 250 }}>
//                     {itensMenu.map((item) =>
//                         item.submenu ? (
//                             <React.Fragment key={item.texto}>
//                                 <ListItem disablePadding>
//                                     <ListItemButton onClick={() => setSubmenuAberto(!submenuAberto)}>
//                                         <ListItemIcon>{item.icone}</ListItemIcon>
//                                         <ListItemText primary={item.texto} />
//                                         {submenuAberto ? <ExpandLess /> : <ExpandMore />}
//                                     </ListItemButton>
//                                 </ListItem>
//                                 <Collapse in={submenuAberto} timeout="auto" unmountOnExit>
//                                     <List component="div" disablePadding>
//                                         {item.submenu.map((subitem) => (
//                                             <ListItem key={subitem.texto} disablePadding>
//                                                 <ListItemButton
//                                                     component={RouterLink}
//                                                     to={subitem.to}
//                                                     sx={{ pl: 4 }}
//                                                     onClick={() => setMenuAberto(false)}
//                                                 >
//                                                     <ListItemIcon>{subitem.icone}</ListItemIcon>
//                                                     <ListItemText primary={subitem.texto} />
//                                                 </ListItemButton>
//                                             </ListItem>
//                                         ))}
//                                     </List>
//                                 </Collapse>
//                             </React.Fragment>
//                         ) : (
//                             <ListItem key={item.texto} disablePadding>
//                                 <ListItemButton component={RouterLink} to={item.to} onClick={() => setMenuAberto(false)}>
//                                     <ListItemIcon>{item.icone}</ListItemIcon>
//                                     <ListItemText primary={item.texto} />
//                                 </ListItemButton>
//                             </ListItem>
//                         )
//                     )}
//                 </List>
//             </Drawer>
//         </AppBar>
//     );
// };

// export default BarraSuperiorEsquerda;






// // Arquivos que demonstra a Barra Superior Esquerda com a opções de Rotinas

// import { AppBar, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography, IconButton } from '@mui/material';
// import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
// import HomeIcon from '@mui/icons-material/Home';
// import MenuIcon from '@mui/icons-material/Menu';
// import SettingsIcon from '@mui/icons-material/Settings';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import GroupAddIcon from '@mui/icons-material/GroupAdd';
// import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
// import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
// import DataSaverOnIcon from '@mui/icons-material/DataSaverOn';
// import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
// import PublicIcon from '@mui/icons-material/Public';
// import MedicationIcon from '@mui/icons-material/Medication';
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
// import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
// import { DataAtualDMYContext } from '../../context/DataAtualDMYContext';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import MapIcon from '@mui/icons-material/Map';
// import { TitleContext } from '../../context/TitleContext';
// import React, { useState, useContext } from 'react';
// import { Link as RouterLink } from 'react-router-dom';

// const BarraSuperiorEsquerda = () => {
//     const [menuAberto, setMenuAberto] = useState(false); // Para que o menu venha com a opção fechada
//     const { title } = useContext(TitleContext);
//     const { dataAtual } = useContext(DataAtualDMYContext);

//     const itensMenu = [
//         {
//             texto: 'Início',
//             icone: (<HomeIcon />),
//             to: '/'
//         },
//         {
//             texto: 'Pacientes',
//             icone: (<PersonAddAlt1Icon />),
//             to: '/pacientes',
//         },
//         {
//             texto: 'Profissionais',
//             icone: (<GroupAddIcon />),
//             to: '/profissionais',
//         },
//         {
//             texto: 'Especializações',
//             icone: (<MedicalInformationIcon />),
//             to: '/especializacoes',
//         },
//         // {
//         //     texto: 'Profissionais & Especializações',
//         //     icone: (<PublicIcon />),
//         //     to: '/prof_espec'
//         // },
//         {
//             texto: 'Tipos de Consultas',
//             icone: (<LibraryAddIcon/>),
//             to: '/tiposConsultas',
//         },
//         {
//             texto: 'Tipos Pagtos Profissionais',
//             icone: (<PlaylistAddCircleIcon />),
//             to: '/tiposPagtosProf',
//         },
//         {
//             texto: 'Formas Atend. Profissionais',
//             icone: (<DataSaverOnIcon />),
//             to: '/formasAtendProf',
//         },
//         {
//             texto: 'Planos de Saúde',
//             icone: (<HealthAndSafetyIcon />),
//             to: '/planosSaude',
//         },
//         {
//             texto: 'Profissionais & Planos de Saúde',
//             icone: (<ManageAccountsIcon />),
//             to: '/profPlanosSaude',
//         },
//         {
//             texto: 'Tabela de Preços',
//             icone: (<MonetizationOnIcon />),
//             to: '/tabelasPrecos'
//         },
//         {
//             texto: 'Atendimentos',
//             icone: (<MedicationIcon />),
//             to: '/atendimentos'
//         },
//         {
//             texto: 'Estados',
//             icone: (<MapIcon />),
//             to: '/estados'
//         },
//         {
//             texto: 'Cidades',
//             icone: (<LocationOnIcon />),
//             to: '/cidades'
//         },
//         {
//             texto: 'Configurações',
//             icone: (<SettingsIcon />),
//             to: '/settings'
//         },
//     ];

//     return (
//         <AppBar position='static'>
//             <Toolbar>
//                 <MenuIcon sx={{ cursor: 'pointer' }} onClick={(e) => setMenuAberto(true)} />
//                 <Typography component="h1" variant="h6" noWrap sx={{ flexGrow: 1, ml: 4 }}>
//                     {title}
//                 </Typography>
//                 <Typography component="h1" variant="h6" noWrap sx={{ flexGrow: 1, ml: 80 }}>
//                     {dataAtual}
//                 </Typography>
//             </Toolbar>
//             <Drawer anchor='left' open={menuAberto} onClose={(e) => setMenuAberto(false)}>
//                 <Toolbar
//                     sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'flex-end',
//                         px: [1],
//                     }}
//                 >
//                     <IconButton edge="start" onClick={(e) => setMenuAberto(false)}>
//                         <ChevronLeftIcon />
//                     </IconButton>
//                 </Toolbar>
//                 <Divider />
//                 <List sx={{ width: 250 }}>
//                     {itensMenu.map(itemMenu => (
//                         <ListItem disablePadding key={itemMenu.texto}>
//                             <ListItemButton component={RouterLink} to={itemMenu.to} onClick={() => setMenuAberto(false)}>
//                                 <ListItemIcon>{itemMenu.icone}</ListItemIcon>
//                                 <ListItemText primary={itemMenu.texto} />
//                             </ListItemButton>
//                         </ListItem>
//                     ))}
//                 </List>
//             </Drawer>
//         </AppBar>
//     );
// }

// export default BarraSuperiorEsquerda;
